import React, { useEffect, useRef } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, useParams, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import CarDetail from "./pages/CarDetail";
import PaymentResult from "./pages/PaymentResult";
import Privacy from "./pages/Privacy";
import Condizioni from "./pages/Condizioni";
import { Toaster } from "./components/ui/sonner";
import PointerDot from "./components/PointerDot";
import SocialProof from "./components/SocialProof";
import WelcomePopup from "./components/WelcomePopup";
import Intro from "./components/Intro";
import ConsentBanner from "./components/ConsentBanner";
import * as meta from "./lib/meta";

function HashScroll() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      let tries = 0;
      const scroll = () => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
        tries += 1;
        if (tries < 6) setTimeout(scroll, 220);
      };
      const t = setTimeout(scroll, 120);
      return () => clearTimeout(t);
    }
    if (pathname === "/") window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
}

function LegacyProductRedirect() {
  const { handle } = useParams();
  return <Navigate to={`/auto/${handle}`} replace />;
}

// Fires one Meta PageView per real SPA route change (initial load is handled
// by enableMetaPixel to avoid a double PageView).
function MetaRouteTracker() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    meta.pageView();
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    if (meta.hasConsent()) meta.enableMetaPixel();
    else meta.revokeMetaPixel();
    meta.initContactTracking();
  }, []);
  return (
    <div className="App">
      <Intro />
      <BrowserRouter>
        <HashScroll />
        <MetaRouteTracker />
        <PointerDot />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auto" element={<Catalog />} />
          <Route path="/auto/:handle" element={<CarDetail />} />
          {/* Legacy Shopify URLs -> canonical /auto/:handle (client redirect;
              a true HTTP 301 is set at the deploy/ingress layer). */}
          <Route path="/products/:handle" element={<LegacyProductRedirect />} />
          <Route path="/products" element={<Navigate to="/auto" replace />} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/condizioni" element={<Condizioni />} />
        </Routes>
        <Toaster position="bottom-right" />
        <WelcomePopup />
        <SocialProof />
        <ConsentBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
